/**
 * Checks if the code is running in a Chromatic environment.
 * Replicates the logic from chromatic-cli's isChromatic function.
 * @link https://github.com/chromaui/chromatic-cli/blob/main/isChromatic.js
 */
export const isChromatic = (windowArgument?: Window): boolean => {
  const windowToCheck = windowArgument || (globalThis.window !== undefined && globalThis.window);

  return (
    windowToCheck &&
    (/Chromatic/.test(windowToCheck.navigator.userAgent) || /chromatic=true/.test(windowToCheck.location.href))
  );
};
